import type { FormData } from '../components/drawer-filter';
import useSOSFilingStatesQueryParams from './use-sos-filings-states-query-params';

const useInitialSOSFilingsFilters = () => {
  const { values } = useSOSFilingStatesQueryParams();

  const emptyValues: FormData = {
    states: [],
  };

  const defaultValues = (() => {
    const defaultData: FormData = {
      states: [],
    };
    if (values.filingsStates) {
      defaultData.states = values.filingsStates;
    }
    return defaultData;
  })();

  return { emptyValues, defaultValues };
};

export default useInitialSOSFilingsFilters;
